/**
 * Sombras discretas — o Design System do ERP prioriza densidade de
 * informação e hierarquia por peso tipográfico, não por sombra pesada
 * (ver ARCHITECTURE_GUIDE.md / referência de estilo: Linear, não
 * dashboards genéricos de template).
 */
export const SHADOWS = {
    'shadow-sm': '0 1px 2px rgba(0, 0, 0, 0.4)',
    'shadow-md': '0 4px 12px rgba(0, 0, 0, 0.35)',
    'shadow-lg': '0 12px 32px rgba(0, 0, 0, 0.45)',
    'shadow-foco': '0 0 0 3px rgba(47, 140, 255, 0.35)',
};
//# sourceMappingURL=shadows.js.map